import PropTypes from 'prop-types'

const FileTypeIcon = ({ type, modifier }) => {
  return (
    <div className={`FileTypeIcon ${modifier ? `FileTypeIcon--${modifier}` : ''}`}>
      <div className="FileTypeIcon-block">
        <div className={`FileTypeIcon-label FileTypeIcon-label--${type}`}>{type}</div>
        <div className="FileTypeIcon-bg"></div>
      </div>
    </div>
  )
}

FileTypeIcon.propTypes = {
  type: PropTypes.string.isRequired,
  modifier: PropTypes.string
}

export default FileTypeIcon
